import { IItemSelection } from '@app/components/common/SelectionModal/GenericSelectionModal/types';
import { MenuTypeStatus } from '@app/components/common/SelectionModal/MenuTypesSelectionModal/Filter/types';
import UsersSelectionModal from '@app/components/common/SelectionModal/UsersSelectionModal';
import { emailReportMobile } from '@app/state/reports/reportsWebActions';
import { selectLoggedInUser } from '@app/state/selectors/appSelectors';
import { useAppDispatch } from '@app/state/store';
import {
  usersSelectors,
  settingsSelectors,
  usersSelectionValuesFactory,
} from '@westondev/tableturn-core';
import { useMemo } from 'react';
import { WithTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

interface IEmailReportModal extends WithTranslation {
  isModalOpen: boolean;
  setIsModalOpen: (isOpen: boolean) => void;
  setIsSendingEmail: (isSendingEmail: boolean) => void;
}

const EmailReportModal = ({
  t,
  isModalOpen,
  setIsModalOpen,
  setIsSendingEmail,
}: IEmailReportModal) => {
  const dispatch = useAppDispatch();

  const currentOrgUserId = useSelector(selectLoggedInUser)?.organizationUserId;
  const users = useSelector(usersSelectors.selectUsers);
  const roles = useSelector(settingsSelectors.selectRoles);

  const formattedUsersArray = useMemo(() => {
    return usersSelectionValuesFactory(users, true).map(userCard => ({
      ...userCard,
      roles: userCard.roleIds?.map(roleId => roles[roleId]?.name),
    }));
  }, [users, roles]);

  const closeModal = () => setIsModalOpen(false);

  const handleOnAssociate = (selectedUsers: IItemSelection[]) => {
    const selectedUserIds = selectedUsers?.map(user => Number(user.id)) ?? [];
    if (!selectedUserIds.length) return;
    closeModal();
    setIsSendingEmail(true);
    dispatch(emailReportMobile(selectedUserIds)).finally(() =>
      setIsSendingEmail(false),
    );
  };

  return (
    <UsersSelectionModal
      buttons={formattedUsersArray}
      selectedButtonIds={[currentOrgUserId]}
      onAssociate={handleOnAssociate}
      onModalClose={closeModal}
      active={isModalOpen}
      allowAssociateMultiple
      showDescriptionPanel={false}
      associateOnSelect={false}
      showSelectedButtons
      showCommonFilter={false}
      defaultFilterValue={MenuTypeStatus.all}
      currentButtonInfo={undefined}
      btnSuccessText={t('commonButtons.send')}
    />
  );
};

export default EmailReportModal;
